import { Moment } from '@intelipost-js/secure-providers';

export default {
  loading: false,
  invoices: [],
  form: {
    logistic_providers: [],
    delivery_methods: [],
    status: [],
    warehouses: [],
    date_range: {
      start: Moment()
        .subtract(1, 'days')
        .format('YYYY-MM-DD'),
      end: Moment().format('YYYY-MM-DD'),
    },
    search_by: 'order_number',
    search_values: [],
    table_form: {},
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/pre-invoice-audit/store/states.js